import MainLayout from "../components/layouts/MainLayout";
import {getCookiePreferences} from "../helpers/cookies";
import localized from "../locale/locales";
import {useRouter} from "next/router";
import Hero from "../components/Hero";
import Title from "../components/Title";
import Container from "../components/Container";
import Typo from "../components/Typo";
import TextWithImageAlt from "../components/TextWithImageAlt";
import {getCachedJobPositions} from "../helpers/jobs";
import SectionJobs from "../components/sections/SectionJobs";
import weightsImage from "../public/img/jobs_intro.jpg";
// import FeaturesGrid from "../components/FeaturesGrid";

// import iconSkillrow from "../public/img/icons/skillrow.png";
// import iconSkillmill from "../public/img/icons/skillmill.png";
// import iconAirbike from "../public/img/icons/airbike.png";

// const icons = [
//     iconSkillrow,
//     iconSkillmill,
//     iconAirbike
// ];

export default function Jobs({hasCookiePreferences, cookiePreferences, jobs}) {
    const {locale} = useRouter();
    const {jobs: lang, og} = localized[locale];

    return (
        <MainLayout hasCookiePreferences={hasCookiePreferences}
                    cookiePreferences={cookiePreferences}
                    footerTheme="dark"
                    title={lang.og?.title || lang.title}
        >
            <div>
                <Hero size="narrow" bgPosition="center" image="jobs">
                    <div className="flex flex-col gap-4 max-w-[22rem]">
                        <header>
                            <Title Elem="h1">{lang.title}</Title>
                        </header>
                    </div>
                </Hero>
            </div>

            <Container className="py-16 md:py-24">
                <blockquote className="max-w-[28ch] mx-auto text-center text-3xl">
                    {lang.quote}
                </blockquote>
            </Container>

            <TextWithImageAlt
                image={weightsImage}
                imageAlt=""
                imageRatio="aspect-[13/12] max-w-[450px]"
                childrenClasses="max-w-lg pt-16 md:pt-622"
            >
                <Typo className="max-w-[42ch]">
                    {lang.intro}
                </Typo>
            </TextWithImageAlt>

            <SectionJobs jobs={jobs} className="py-16 md:py-24 lg:mt-12"/>

            {/*<div className="bg-black text-white text-center">*/}
            {/*    <Container className="py-16 md:py-24 flex flex-col gap-12 md:gap-20">*/}
            {/*        <header>*/}
            {/*            <Title className="max-w-[10ch] md:max-w-max text-center mx-auto">*/}
            {/*                {lang.features.title}*/}
            {/*            </Title>*/}
            {/*        </header>*/}

            {/*        <FeaturesGrid*/}
            {/*            items={lang.features.items.map(({title, body}, key) => {*/}
            {/*                return {*/}
            {/*                    title,*/}
            {/*                    body,*/}
            {/*                    icon: icons[key]*/}
            {/*                }*/}
            {/*            })}*/}
            {/*        />*/}
            {/*    </Container>*/}
            {/*</div>*/}

            <Container className="pb-16 md:pb-24 text-center flex flex-col items-center gap-6">
                <Typo className="max-w-[29ch]">
                    {lang.otherJobs}
                </Typo>
                <a href="mailto:jobs@nextmove.cz"
                   className="text-2xl leading-normal draw-line font-semibold">jobs@nextmove.cz</a>
            </Container>

        </MainLayout>
    )
}


export async function getServerSideProps({req, res}) {
    const cookiePreferences = getCookiePreferences(req);
    const jobs = await getCachedJobPositions();

    return {
        props: {
            ...cookiePreferences,
            jobs
        }
    }
}
